import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, X } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { http, formatErr, waLink } from "@/lib/api";

const BADGE = { assigned: "bg-amber-100 text-amber-800", accepted: "bg-sky-100 text-sky-800", done: "bg-emerald-100 text-emerald-800" };

export default function AssignPartner({ b, partners, onChange }) {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const assign = async (partnerId) => {
    if (!partnerId) return;
    const win = window.open("", "_blank");
    setBusy(true);
    try {
      const { data } = await http.post(`/admin/bookings/${b.id}/assign`, { partner_id: partnerId });
      const text = data.wa_text.replace("{link}", `${window.location.origin}/mitra/tugas/${data.partner_token}`);
      if (win) win.location.href = waLink(data.partner_phone, text);
      const { partner_phone, wa_text, ...rest } = data;
      onChange(rest);
    } catch (e) { win?.close(); toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    try { await http.delete(`/admin/bookings/${b.id}/assign`); const { partner, partner_token, partner_status, ...rest } = b; onChange(rest); }
    catch (e) { toast.error(formatErr(e)); }
  };
  if (!b.partner) {
    return (
      <select data-testid={`admin-assign-${b.code}`} disabled={busy || !partners?.length} value="" onChange={(e) => assign(e.target.value)} className="max-w-[160px] rounded-full border border-slate-200 bg-white px-2 py-1 text-xs outline-none">
        <option value="">{t("asg_choose")}</option>
        {(partners || []).map((p) => <option key={p.id} value={p.id}>{p.name} · {t(`city_${p.city}`)}</option>)}
      </select>
    );
  }
  return (
    <div data-testid={`admin-assigned-${b.code}`} className="space-y-1">
      <p className="text-xs font-semibold text-slate-800">{b.partner.name}</p>
      <span data-testid={`admin-assign-status-${b.code}`} className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-bold ${BADGE[b.partner_status] || BADGE.assigned}`}>{t(`asg_${b.partner_status || "assigned"}`)}</span>
      <div className="flex gap-1">
        <button type="button" onClick={() => assign(b.partner.id)} data-testid={`admin-assign-resend-${b.code}`} title={t("asg_resend")} className="rounded-full bg-[#25D366] p-1 text-white"><MessageCircle className="h-3.5 w-3.5" /></button>
        <button type="button" onClick={remove} data-testid={`admin-assign-remove-${b.code}`} title={t("asg_remove")} className="rounded-full bg-slate-100 p-1 text-slate-500 hover:bg-slate-200"><X className="h-3.5 w-3.5" /></button>
      </div>
    </div>
  );
}
